import type * as React from 'react';

import { table } from '@gitbook/doc-core';
import type { EditorContainer } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';
import { PlaceholderButton } from '@gitbook/spine-react';

/**
 * Placeholder to insert a new card
 */
export function NewTableRecordCard(props: {
    nodeKey: string;
    editor: EditorContainer;
    /** ID of the first text column in the table */
    defaultTextDefinitionId: string | undefined;
}): React.ReactElement {
    const { editor, nodeKey, defaultTextDefinitionId } = props;

    const onPress = () => {
        editor.change((change) => {
            const recordId = table.insertEmptyRecord(change, nodeKey);
            table.moveTableSelection(change, nodeKey, {
                recordId,
                definitionId: defaultTextDefinitionId,
            });
        });
    };

    return (
        <PlaceholderButton
            label="New card"
            icon={Icon.Plus}
            size="large"
            onPress={onPress}
            className="sm:!m-0 h-full"
        />
    );
}
